import { QueryClient } from '@tanstack/react-query'
import * as Sentry from '@sentry/react'

// Queries fail silently by default. A background fetch that 403s is
// almost always "this user's role doesn't grant access to the data
// behind this page" — surfacing it as a toast would spam every
// page-load attempt by a limited-perm role, none of which the user
// can act on. The right UX answer to that 403 is for the page itself
// to render an empty / no-access state, AND for the navigation to
// not surface the page in the first place.
//
// Mutations still toast via the explicit requestErrorsHandler at
// each callsite — those ARE user-initiated and the user can act on
// the failure.
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
      onError: (error) => {
        Sentry.captureException(error)
      },
    },
  },
})

export default queryClient
